import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import api from "../../api/axios";
import { API_IMAGE_BASE_URL } from "../../config/api";
import "./CategoryDetails.css";

const CategoryDetails = () => {
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const [categoryData, setCategoryData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCategoryDetails();
  }, [categoryId]);

  const fetchCategoryDetails = async () => {
    try {
      const res = await api.get(`/user-category/single?id=${categoryId}`);
      if (res.data?.success) {
        setCategoryData(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch category details:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!categoryData) {
    return <div className="error">Category not found</div>;
  }

  return (
    <div className="category-details-page">
      <div className="page-header">
        <button className="back-btn" onClick={() => navigate(-1)}>
          <FiArrowLeft /> Back
        </button>
        <h2>{categoryData.title}</h2>
      </div>

      <div className="details-container">
        <div className="vendor-info-section">
          <h3>Vendor Information</h3>
          <div className="vendor-card">
            <img 
              src={categoryData.user.profile_image ? `${API_IMAGE_BASE_URL}${categoryData.user.profile_image}` : '/uploads/avatardefaultimg.jpeg'}
              alt={categoryData.user.name}
              onError={(e) => { e.target.src = '/uploads/avatardefaultimg.jpeg'; }}
            />
            <div>
              <h4>{categoryData.user.name}</h4>
              <p>{categoryData.user.email}</p>
              <p>{categoryData.user.mobile_number}</p>
            </div>
          </div>
        </div>

        {categoryData.galleryImages?.length > 0 && (
         <div className="gallery-section">
  <h3>Gallery</h3>
  <div className="gallery-grid">
    {categoryData.galleryImages.map((img, index) => (
      <img
        key={index}
        src={
          img?.url
            ? `${API_IMAGE_BASE_URL}${img.url}`
            : "/uploads/avatardefaultimg.jpeg"
        }
        alt={`Gallery ${index + 1}`}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = "/uploads/crayongridabout.jpg";
        }}
      />
    ))}
  </div>
</div>
        )}

        {categoryData.categoryData?.formFields && (
          <div className="form-fields-section">
            <h3>Category Details</h3>
            <div className="fields-grid">
              {Object.entries(categoryData.categoryData.formFields).map(([key, value]) => (
                <div key={key} className="field-item">
                  <label>{key.replace(/_/g, ' ').toUpperCase()}</label>
                  <span>{Array.isArray(value) ? value.join(', ') : value}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {categoryData.categoryData?.pricingCategories?.length > 0 && (
          <div className="pricing-section">
            <h3>Pricing Categories</h3>
            {categoryData.categoryData.pricingCategories.map((category, index) => (
              <div key={index} className="pricing-category">
                <h4>{category.title}</h4>
                <div className="pricing-items">
                  {category.items.map((item, itemIndex) => (
                    <div key={itemIndex} className="pricing-item">
                      <span className="item-name">{item.name}</span>
                      <span className="item-price">{item.defaultPrice}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryDetails;